import { features } from "keys"

const useIdCell = () => {

    const idField = {
        accessorKey: 'id',
        header: "ID",
        showBlurred: true,
        feature: features.id_cell,
        role: "read"
    }

    return idField
}

export default useIdCell
